import React, { useState } from 'react';
import { getDateTextLocalized } from '../../../../js/functions';
import { FormattedMessage, useIntl } from 'react-intl';
import { getLocalizedTaskActivity } from '../../../../_locale/localesLookupTable';

const ActivityViewer = ({ chat, time, isLatestActivity = false }) => {
  const intl = useIntl();
  const [showMore, setShowMore] = useState(false);

  if (chat == undefined) return null;

  const truncatedContent = chat?.newValue ? (
    chat?.oldValue ? (
      `${chat.field === 'dueDate'
        ? getDateTextLocalized(chat?.oldValue, intl)
        : chat?.oldValue && intl.formatMessage({ id: `${chat?.oldValue}_TASK_ACTIVITY`.toUpperCase(), defaultMessage: Array.isArray(chat?.oldValue) ? chat?.oldValue?.filter(Boolean).join(', ') : (chat?.oldValue ?? '').toString() })
      } → ${chat.field === 'dueDate'
        ? getDateTextLocalized(chat?.newValue, intl)
        : chat?.newValue && intl.formatMessage({ id: `${chat?.newValue}_TASK_ACTIVITY`.toUpperCase(), defaultMessage: Array.isArray(chat?.newValue) ? chat?.newValue?.filter(Boolean).join(', ') : (chat?.newValue ?? '').toString() })
      }`
    ) : (
      chat?.field === 'isCompleted' || chat?.field === 'files'
        ? chat?.newValue && intl.formatMessage({ id: `${chat?.newValue}_TASK_ACTIVITY`.toUpperCase(), defaultMessage: Array.isArray(chat?.newValue) ? chat?.newValue?.filter(Boolean).join(', ') : (chat?.newValue ?? '').toString() })
        : chat.field === 'tags'
          ? chat?.newValue && intl.formatMessage({ id: `${chat?.newValue}_TASK_ACTIVITY`.toUpperCase(), defaultMessage: Array.isArray(chat?.newValue) ? chat?.newValue?.filter(Boolean).join(', ') : (chat?.newValue ?? '').toString() })
          : `${intl.formatMessage({ id: 'TO_TASK_ACTIVITY', defaultMessage: 'to' })} ${chat.field === 'assignee'
            ? intl.formatMessage({ id: 'ASSIGNEE_TASK_ACTIVITY', defaultMessage: 'Assignee' })
            : chat.field === 'dueDate'
              ? getDateTextLocalized(chat?.newValue, intl)
              : chat?.newValue && intl.formatMessage({ id: `${chat?.newValue}_TASK_ACTIVITY`.toUpperCase(), defaultMessage: Array.isArray(chat?.newValue) ? chat?.newValue?.filter(Boolean).join(', ') : (chat?.newValue ?? '').toString() })
          }`
    )
  ) : '';

  const isCompleted = chat?.field === 'isCompleted' && chat?.newValue === 'complete';
  const actorName = chat?.actor?.fullName || '';
  const actionText = chat?.action === 'workfloMigration'
    ? intl.formatMessage({ id: 'WORKFLO_MIGRATION_MESSAGE', defaultMessage: 'Task migrated to Workflo' })
    : getLocalizedTaskActivity(chat?.action, intl, chat?.actor?.fullName);

  if (isLatestActivity || isCompleted) {
    return (
      <li className="flex items-start gap-2.5 py-1.5 w-full">
        <div className="flex-shrink-0 mt-0.5">
          {isCompleted
            ? <img alt="mark-complete" src="/images/icons/completedSubtask.svg" className="w-5 h-5 object-contain" />
            : <div className="w-2 h-2 rounded-full mt-1.5 flex-shrink-0" style={{ background: 'rgba(99,102,241,0.4)' }} />
          }
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-baseline gap-1.5 flex-wrap">
            <span className="text-[12.5px] font-semibold" style={{ color: isCompleted ? '#059669' : '#4f46e5' }}>
              {actorName}
            </span>
            <span className="text-[12.5px]" style={{ color: isCompleted ? '#059669' : 'rgba(99,102,241,0.8)' }}>
              {isCompleted
                ? intl.formatMessage({ id: 'completed_TASK_ACTIVITY', defaultMessage: 'completed this task' })
                : getLocalizedTaskActivity(chat?.action, intl, '')}
            </span>
            <span className="text-[11px]" style={{ color: 'rgba(15,15,25,0.35)' }}>· {time}</span>
          </div>
          {truncatedContent && chat?.field !== 'isCompleted' && (
            <div className="mt-0.5 text-[12px]" style={{ color: 'rgba(15,15,25,0.55)' }}>
              {truncatedContent.replace(/&nbsp;/g, ' ')?.substring(0, showMore ? undefined : 200)}
              {!showMore && truncatedContent.length > 200 && (
                <button className="ml-1 text-[11px] font-medium cursor-pointer" style={{ color: '#4f46e5' }} onClick={() => setShowMore(true)}>
                  <FormattedMessage id="SHOW_MORE" defaultMessage="Show more" />
                </button>
              )}
            </div>
          )}
        </div>
      </li>
    );
  }

  return (
    <li className="relative flex gap-3 pb-4 w-full">
      {/* Timeline */}
      <div className="flex flex-col items-center flex-shrink-0" style={{ width: 20 }}>
        <div className="w-2 h-2 rounded-full mt-1.5 flex-shrink-0" style={{ background: 'rgba(99,102,241,0.35)', border: '2px solid rgba(99,102,241,0.15)' }} />
        <div className="flex-1 w-px mt-1" style={{ background: 'rgba(99,102,241,0.1)', minHeight: 12 }} />
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0 pb-1">
        <div className="flex items-start justify-between gap-2">
          <div className="flex-1 min-w-0">
            <span className="text-[12.5px] font-semibold" style={{ color: '#4f46e5' }}>
              {actorName}{' '}
            </span>
            <span className="text-[12.5px] font-medium" style={{ color: 'rgba(15,15,25,0.65)' }}>
              {actionText}
            </span>
          </div>
          <span className="text-[11px] flex-shrink-0 whitespace-nowrap" style={{ color: 'rgba(15,15,25,0.35)' }}>
            {time}
          </span>
        </div>
        {truncatedContent && (
          <div className="mt-1 text-[12px] px-2 py-1 rounded-md" style={{ color: 'rgba(15,15,25,0.6)', background: 'rgba(99,102,241,0.04)', border: '1px solid rgba(99,102,241,0.08)' }}>
            {truncatedContent.replace(/&nbsp;/g, ' ')?.substring(0, showMore ? undefined : 300)}
            {!showMore && truncatedContent.length > 300 && (
              <button className="ml-1 text-[11px] font-medium cursor-pointer" style={{ color: '#4f46e5' }} onClick={() => setShowMore(true)}>
                <FormattedMessage id="SHOW_MORE" defaultMessage="Show more" />
              </button>
            )}
          </div>
        )}
      </div>
    </li>
  );
};

export default ActivityViewer;
